
/**
 * 프로젝트 파일 정보
 */
export type ProjectListResponsePageAllOfThreeContentItemFileInfo = {
  /** 파일 검증 완료 여부 */
  isVerified?: boolean;
  /** 프로젝트 미디어 파일 경로 목록 (스토리지 경로 등) */
  mediaPaths?: string[];
  /** 프로젝트 ZIP 파일 경로 (스토리지 경로 등) */
  projectZipFilePath?: string;
  /** 프로젝트 ZIP 파일 크기 (bytes) */
  projectZipFileSize?: number;
};
